import React, { useState, useEffect } from "react";
import "./EntranceTable.scss";
import { useNavigate } from "react-router-dom";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";

// Icons
import {
  FaTable,
  FaEnvelope,
  FaUsers,
  FaCalendarAlt,
  FaPhone,
  FaGraduationCap,
  FaIdCard,
  FaCheckCircle,
  FaUser,
  FaSearch,
  FaFilter,
  FaDownload,
  FaPaperPlane,
  FaTimes,
  FaEdit,
} from "react-icons/fa";

const EntranceTable = ({ listname, data, navigateBaseUrl, onSendEmail }) => {
  const navigate = useNavigate();
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isResponseOpen, setIsResponseOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState(data);

  const formatDateAndTime = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return `${formattedDate}`;
  };

  const handleCheckboxChange = (email, isChecked) => {
    setSelectedEmails((prev) =>
      isChecked ? [...prev, email] : prev.filter((e) => e !== email)
    );
  };

  const handleSelectAll = (isChecked) => {
    setIsAllSelected(isChecked);
    setSelectedEmails(isChecked ? filteredData.map((item) => item.email) : []);
  };

  const handleSendEmail = () => {
    if (selectedEmails.length === 0) {
      alert("Please select at least one recipient.");
      return;
    }
    setIsResponseOpen(true);
  };

  const handleSearch = (searchValue) => {
    setSearchTerm(searchValue);
    const filtered = data.filter(
      (item) =>
        item.first_name?.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.middle_name?.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.last_name?.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.roll_no?.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.prev_roll_no?.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.email?.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.whatsapp?.includes(searchValue) ||
        item.aadhar?.includes(searchValue) ||
        item.adm_class?.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredData(filtered);
    setSelectedEmails([]);
    setIsAllSelected(false);
  };

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  useEffect(() => {
    if (isAllSelected) {
      setSelectedEmails(filteredData.map((item) => item.email));
    } else {
      setSelectedEmails([]);
    }
  }, [isAllSelected, filteredData]);

  return (
    <div className="entrance-table-container">
      {/* Modal for email content */}
      <Modal isOpen={isResponseOpen} onClose={() => setIsResponseOpen(false)}>
        <EmailComp
          selectedEmails={selectedEmails}
          onSendEmail={onSendEmail}
          onClose={() => setIsResponseOpen(false)}
        />
      </Modal>

      {/* Header Section */}
      {/* <div className="entrance-table-header-section">
        <div className="entrance-table-header-left">
          <div className="entrance-table-header-icon">
            <FaTable />
          </div>
          <div className="entrance-table-header-content">
            <h1 className="entrance-table-title">{listname}</h1>
            <p className="entrance-table-subtitle">
              Manage student applications and communications
            </p>
          </div>
        </div>
        <div className="entrance-table-header-right">
          <div className="entrance-table-stats">
            <div className="stat-card">
              <FaUsers />
              <div className="stat-info">
                <span className="stat-number">{filteredData.length}</span>
                <span className="stat-label">Total Students</span>
              </div>
            </div>
            <div className="stat-card">
              <FaCheckCircle />
              <div className="stat-info">
                <span className="stat-number">{selectedEmails.length}</span>
                <span className="stat-label">Selected</span>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Controls Section */}
      <div className="entrance-table-controls">
        <div className="entrance-table-controls-left">
          <div className="search-container">
            <FaSearch />
            <input
              type="text"
              placeholder="Search students..."
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              className="search-input"
            />
          </div>
          {/* <div className="filter-controls">
            <button className="filter-btn">
              <FaFilter />
              <span>Filters</span>
            </button>
            <button className="export-btn">
              <FaDownload />
              <span>Export</span>
            </button>
          </div> */}
        </div>
        <div className="entrance-table-controls-right">
          <Button
            onClick={handleSendEmail}
            text={
              <span className="button-with-icon">
                <FaEnvelope />
                Send Email ({selectedEmails.length})
              </span>
            }
            disabled={selectedEmails.length === 0}
          />
        </div>
      </div>

      {/* Table Section */}
      <div className="entrance-table-wrapper">
        <div className="entrance-table">
          {/* Table Header */}
          <div className="entrance-table-header-row">
            <div className="entrance-table-cell checkbox-cell">
              <div className="custom-checkbox">
                <input
                  type="checkbox"
                  id="select-all"
                  className="checkbox-input"
                  checked={isAllSelected}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                />
                <label htmlFor="select-all" className="checkbox-label">
                  <FaCheckCircle className="check-icon" />
                </label>
              </div>
            </div>
            <div className="entrance-table-cell header-cell">
              <FaIdCard />
              <span>Roll No</span>
            </div>
            <div className="entrance-table-cell header-cell">
              <FaUser />
              <span>Student Name</span>
            </div>
            <div className="entrance-table-cell header-cell">
              <FaPhone />
              <span>WhatsApp</span>
            </div>
            <div className="entrance-table-cell header-cell">
              <FaGraduationCap />
              <span>Class</span>
            </div>
            <div className="entrance-table-cell header-cell">
              <FaCalendarAlt />
              <span>Date</span>
            </div>
          </div>

          {/* Table Body */}
          <div className="entrance-table-body">
            {filteredData.length === 0 ? (
              <div className="entrance-table-empty">
                <FaUsers />
                <h3>No students found</h3>
                <p>Try adjusting your search criteria</p>
              </div>
            ) : (
              filteredData.map((item, index) => (
                <div
                  key={item.id}
                  className={`entrance-table-row ${
                    item.percent ? "entrance-table-row-highlighted" : ""
                  } ${selectedEmails.includes(item.email) ? "selected" : ""}`}
                >
                  <div className="entrance-table-cell checkbox-cell">
                    <div className="custom-checkbox">
                      <input
                        type="checkbox"
                        id={`checkbox-${item.id}`}
                        className="checkbox-input"
                        checked={selectedEmails.includes(item.email)}
                        onChange={(e) =>
                          handleCheckboxChange(item.email, e.target.checked)
                        }
                      />
                      <label
                        htmlFor={`checkbox-${item.id}`}
                        className="checkbox-label"
                      >
                        <FaCheckCircle className="check-icon" />
                      </label>
                    </div>
                  </div>
                  <div
                    className="entrance-table-row-content"
                    onClick={() =>
                      navigate(`${navigateBaseUrl}/${item.roll_no}`)
                    }
                  >
                    <div className="entrance-table-cell data-cell roll-no">
                      <span className="cell-data">{item.roll_no}</span>
                    </div>
                    <div className="entrance-table-cell data-cell student-name">
                      <div className="student-info">
                        <div className="student-avatar">
                          <FaUser />
                        </div>
                        <div className="student-details">
                          <span className="student-name">
                            {`${item.first_name} ${item.middle_name} ${item.last_name}`}
                          </span>
                          <span className="student-email">{item.email}</span>
                        </div>
                      </div>
                    </div>
                    <div className="entrance-table-cell data-cell whatsapp">
                      <span className="cell-data phone-number">
                        {item.whatsapp}
                      </span>
                    </div>
                    <div className="entrance-table-cell data-cell class-info">
                      <span className="class-badge">{item.adm_class}</span>
                    </div>
                    <div className="entrance-table-cell data-cell date">
                      <span className="cell-data">
                        {formatDateAndTime(item.timestamp)}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {/* Footer Section */}
      {filteredData.length > 0 && (
        <div className="entrance-table-footer">
          <div className="entrance-table-footer-info">
            <span>
              Showing {filteredData.length} of {data.length} students
            </span>
            {selectedEmails.length > 0 && (
              <span className="selected-info">
                • {selectedEmails.length} selected
              </span>
            )}
          </div>
          <div className="entrance-table-footer-actions">
            {selectedEmails.length > 0 && (
              <button
                className="clear-selection-btn"
                onClick={() => {
                  setSelectedEmails([]);
                  setIsAllSelected(false);
                }}
              >
                Clear Selection
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default EntranceTable;

function EmailComp({ selectedEmails, onSendEmail, onClose }) {
  const [subject, setSubject] = useState("Important Information");
  const [body, setBody] = useState("");

  const handleSend = () => {
    if (!subject.trim() || !body.trim()) {
      alert("Subject and body cannot be empty.");
      return;
    }

    onSendEmail({ emails: selectedEmails, subject, body });
    onClose();
  };

  return (
    <div className="email-composer">
      <div className="email-composer-header">
        <div className="email-composer-header-left">
          <div className="email-composer-icon">
            <FaEnvelope />
          </div>
          <div className="email-composer-title">
            <h2>Compose Email</h2>
            <p>Sending to {selectedEmails.length} recipients</p>
          </div>
        </div>
        <button className="email-composer-close" onClick={onClose}>
          <FaTimes />
        </button>
      </div>

      <div className="email-composer-content">
        <div className="email-field-group">
          <label className="email-field-label">
            <FaEdit />
            <span>Subject</span>
          </label>
          <input
            type="text"
            className="email-field-input"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="Enter email subject"
          />
        </div>

        <div className="email-field-group">
          <label className="email-field-label">
            <FaEdit />
            <span>Message</span>
          </label>
          <textarea
            className="email-field-textarea"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Write your message here..."
            rows="8"
          />
        </div>

        <div className="email-recipients-preview">
          <div className="email-recipients-header">
            <FaUsers />
            <span>Recipients ({selectedEmails.length})</span>
          </div>
          <div className="email-recipients-list">
            {selectedEmails.slice(0, 5).map((email, index) => (
              <span key={index} className="recipient-tag">
                {email}
              </span>
            ))}
            {selectedEmails.length > 5 && (
              <span className="recipient-tag more">
                +{selectedEmails.length - 5} more
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="email-composer-footer">
        <button className="email-btn cancel-btn" onClick={onClose}>
          <FaTimes />
          <span>Cancel</span>
        </button>
        <button
          className="email-btn send-btn"
          onClick={handleSend}
          disabled={!subject.trim() || !body.trim()}
        >
          <FaPaperPlane />
          <span>Send Email</span>
        </button>
      </div>
    </div>
  );
}
